export default "__VITE_ASSET__9ykgGK6$__"